import script from "./PersonalDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalDetails.vue?vue&type=script&setup=true&lang=js"

import "./PersonalDetails.vue?vue&type=style&index=0&id=4f52e7f6&lang=css"

const __exports__ = script;

export default __exports__